<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Protesto Cheque
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Finanzas</span>
      <span> /</span>
      <span>Protesto</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<app-cheques-protesto-cabecera (onSearch)="onSearch($event)" (onSearchAll)="onSearchAll()">
</app-cheques-protesto-cabecera>

<app-cheques-protesto-detalles></app-cheques-protesto-detalles>